
import { defineComponent } from "vue";

export default defineComponent({
  name: "DhTableHeader",
  props: ["columns"],
});
